"use client";
import React, { Fragment, useState } from "react";
import { useTranslation } from "@/src/i18n/client";
import { FmButton, FmDrawer } from "@/ui-component";
import { IPurchaseProps } from "..";
import stl from "./productAdvantage.module.scss";
import WarrantyTime from "./WarrantyTime";
import WarrantyTimeTips from "./WarrantyTimeTips";
interface IProps extends IPurchaseProps {}
const ProductAdvantageClient: React.FC<React.PropsWithChildren<IProps>> = (
    props,
) => {
    const [visible, setVisible] = useState(false);
    const toggerVisible = () => {
        setVisible((prev) => !prev);
    };

    const { t } = useTranslation("common");
    return (
        <>
            {props.children}
            <FmButton
                className={stl["hidden-util-lconlast"]}
                onClick={toggerVisible}
                variant="text"
                width="fit-content"
            >
                <span className={stl["view-more-btn"]}>
                    {t("common:helpPage.ViewMore")}
                </span>
            </FmButton>
            <FmDrawer
                open={visible}
                closeable={true}
                onClose={toggerVisible}
                anchor="bottom"
                closeablePosition="right"
                fullHeight
                headerChildren
                childrenClassName={stl["modal-container"]}
                headerClassName={stl["modal-header-container"]}
            >
                {props.H5Purchase.viewmore.length > 0 ? (
                    <>
                        {props.H5Purchase.viewmore.map(
                            (item: any, index: number) => (
                                <Fragment key={index}>
                                    <p className={stl["advantage-modal-title"]}>
                                        {item.title}
                                    </p>
                                    <p className={stl["advantage-modal-text"]}>
                                        {item.text}
                                    </p>
                                </Fragment>
                            ),
                        )}
                    </>
                ) : (
                    <>
                        <p className={stl["advantage-modal-title"]}>
                            {t("common:advantage.title1")}
                        </p>
                        <p className={stl["advantage-modal-text"]}>
                            {t("common:DAY_EXCHANEG_TIPS")}
                        </p>
                        <p className={stl["advantage-modal-title"]}>
                            <WarrantyTime />
                        </p>
                        <p className={stl["advantage-modal-text"]}>
                            <WarrantyTimeTips />
                        </p>
                    </>
                )}
            </FmDrawer>
        </>
    );
};

export default ProductAdvantageClient;
